import { getServerApi } from '@/gql';
import { Permit } from '@/gql/graph/__generated__/request';
import user from '@/stores/user';
import { useState } from 'react';

export interface UseCreateMemoryPermitResult {
    permit: Permit | null;
    loading: boolean;
    error: Error | null;
    getCreateMemoryPermit: () => Promise<Permit | null>;
}

export const useCreateMemoryPermit = (
    tokenId: number,
): UseCreateMemoryPermitResult => {
    const [permit, setPermit] = useState<Permit | null>(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<Error | null>(null);
    const { userId } = user;

    const getCreateMemoryPermit = async () => {
        if (!tokenId || !userId) {
            setPermit(null);
            return null;
        }
        try {
            setLoading(true);
            setError(null);
            const api = getServerApi();
            const response = await api.createMemoryPermit({
                tokenId: tokenId,
            });
            if (response?.createMemoryPermit !== undefined) {
                setPermit(response.createMemoryPermit);
                return response.createMemoryPermit;
            } else {
                setPermit(null);
                return null;
            }
        } catch (err) {
            console.error('Failed to fetch permit:', err);
            setError(
                err instanceof Error
                    ? err
                    : new Error('Failed to fetch permit'),
            );
            setPermit(null);
            return null;
        } finally {
            setLoading(false);
        }
    };

    return {
        permit,
        loading,
        error,
        getCreateMemoryPermit,
    };
};
